import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  type?: "website" | "product" | "article";
}

const SEOHead = ({ title, description, canonical, type = "website" }: SEOHeadProps) => {
  useEffect(() => {
    // Update document title
    document.title = `${title} | AMS DISTRIB`;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    const ogType = document.querySelector('meta[property="og:type"]');
    
    if (ogTitle) ogTitle.setAttribute("content", title);
    if (ogDescription) ogDescription.setAttribute("content", description);
    if (ogType) ogType.setAttribute("content", type);
    
    // Update canonical if provided
    if (canonical) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute("href", canonical);
    }
    
    return () => {
      // Reset to default on unmount
      document.title = "AMS DISTRIB | Fournisseur Emballage Alimentaire Bordeaux";
    };
  }, [title, description, canonical, type]);
  
  return null;
};

export default SEOHead;